import { numberToPrettyString } from '@cian/utils';

import { IAvgPriceInformer } from '../../../types/offersData';

const CURRENCY_SYMBOL: Record<IAvgPriceInformer['currency'], string> = {
  rur: '₽',
  eur: '€',
  usd: '$',
};

export interface IFormattedAvgPrice {
  value: string;
  unit: string;
}

export function formatAvgPrice(
  { price, currency }: IAvgPriceInformer,
  options: { isRent: boolean },
): IFormattedAvgPrice {
  const symbol = CURRENCY_SYMBOL[currency];
  const suffix = options.isRent ? `${symbol}/мес.` : symbol;

  if (price >= 1_000_000) {
    return {
      value: (price / 1_000_000).toFixed(2).replace('.', ','),
      unit: `млн ${suffix}`,
    };
  }

  if (price >= 1_000) {
    return {
      value: numberToPrettyString(Math.round(price / 1_000)),
      unit: `тыс. ${suffix}`,
    };
  }

  return {
    value: numberToPrettyString(price),
    unit: suffix,
  };
}
